import type { ReactElement, ReactNode } from 'react';
import React, { Children } from 'react';

import { useTabs } from '../Tabs';

type TabPanelsProps = {
  children: ReactNode;
};

const TabPanels = ({ children }: TabPanelsProps) => {
  const { activeIndex, id } = useTabs();

  return (
    <div className="TabPanels">
      {Children.map(children, (child, index) =>
        React.cloneElement(child as ReactElement, {
          'aria-labelledby': `${id}-tab-${index}`,
          id: `${id}-panel-${index}`,
          isActive: index === activeIndex,
        }),
      )}
    </div>
  );
};

TabPanels.displayNane = 'TabPanels';

export { TabPanels };
